import { Box, Text } from "@biblioteksentralen/react";
import { ResolvedEmployee } from "@libry-content/common";
import { ContactCardWrapper } from "./ContactCard";
import { useTranslation } from "../../utils/hooks/useTranslation";

interface Props {
  employee: ResolvedEmployee;
  hidePositionAndAffiliations?: boolean;
}

const EmployeeCard = ({ employee, hidePositionAndAffiliations }: Props) => {
  const { ts } = useTranslation();
  if (!employee || !employee.showEmployee) {
    return null;
  }
  return (
    <ContactCardWrapper
      employeeOrLibrary={employee}
      email={employee.showEmail ? employee.email : undefined}
      phone={employee.phone}
      name={employee.name!}
      contactFormUrl={employee.contactFormUrl}
      positionAndAffiliations={
        !hidePositionAndAffiliations && (
          <Box>
            {ts(employee.position) && <Text>{ts(employee.position)}</Text>}
            {employee.libraries?.map((library) => (
              <Text key={library?._id}>{ts(library?.name)}</Text>
            ))}
          </Box>
        )
      }
    />
  );
};

export default EmployeeCard;
